import React from 'react';
import videojs from 'video.js'
import './player.css'
import videozhCN from 'video.js/dist/lang/zh-CN.json'; //播放器中文，不能使用.js文件
import 'video.js/dist/video-js.css';  //样式文件注意要加上
import AppUtils from '../../control/apputlis';
// import 'videojs-flash'; 

export default class Player extends React.Component {

    canPlay = true;

    constructor(props) {
        super(props);
        this.state = {
            fullscreen: false,
            ImageUrl: this.props.ImageUrl,
            Times: 1,
            showAds: false,
        };
        this.onClickAds = this.onClickAds.bind(this);
        // document.body.style.overflow = 'hidden';
    }

    componentDidMount() {
        let that = this;

        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
            if (that.state.ImageUrl && that.state.ImageUrl.length > 0) {
                that.setState({ showAds: true });
                this.timer =
                    setTimeout(() => {
                        that.play();
                    }, that.state.Times);
            } else {
                this.timer =
                    setTimeout(() => {
                        that.play();
                    }, 200);
            }
        });

        videojs.addLanguage('zh-CN', videozhCN);

        let isCallBack = false;
        this.player.on('timeupdate', function (e) {
            let curTime = that.player.currentTime();
            if (isCallBack) {
                return;
            }
            if (that.props.callTime && that.props.callTime > 0) {
                if (curTime > that.props.callTime) {
                    if (that.props.callTimeBack) {
                        that.props.callTimeBack();
                        isCallBack = true;
                    }
                }
            }
        });

        this.player.on('play', function (e) {
            if (that.props.playValid) {
                that.props.playValid();
            }
        });

        this.player.on('fullscreenchange', function (e) {
            this.setState({ fullscreen: this.player.isFullscreen() });
        }.bind(this));
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    changeRouter = (url) => {
        if (this.player) {
            this.player.src({ src: url, type: 'application/x-mpegURL' })
        }
    }

    stopPlay() {
        if (this.player) {
            this.player.pause();
        }
    }

    play() {
        if (this.player && this.player.player_) {
            this.player.play().catch(error => {
                console.log(error);
            });
            this.setState({ showAds: false });
        }
        if (this.props.onPlayerReady) {
            this.props.onPlayerReady();
        }
    }

    onClickAds() {
        if (this.props.LinkUrl && this.props.LinkUrl.length > 0) {
            AppUtils.openUrl(this.props.LinkUrl)
        }
    }

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    render() {
        const { fullscreen, ImageUrl, showAds } = this.state;
        let style = { width: '100%' };
        if (fullscreen) {
            style = { width: '100%' };
        } else {
            style = { width: '100%', height: '56vw' };
        }
        return (
            <div>
                <div data-vjs-player>
                    <video
                        x5-playsinline="true"
                        playsInline={true}
                        webkit-playsinline="true"
                        x-webkit-airplay="allow"
                        data-setup='{"techOrder": ["html5"], "controlBar": { "muteToggle": false, "volumeControl": false,"timeDivider": false,"durationDisplay": false,"progressControl": true } }'
                        style={style}
                        ref={node => this.videoNode = node} className="video-js vjs-default-skin video vjs-big-play-centered ">
                    </video>
                    {
                        showAds ? <div style={{ position: 'absolute', zIndex: 1000 }}>
                            <img width='100%' height={'56vw'} src={ImageUrl} alt='banner' onClick={() => this.onClickAds}></img>
                        </div> : null
                    }
                </div>
            </div>
        )
    }
}